import { render } from "./PackageDetailsPage.vue?vue&type=template&id=172b333a"
import script from "./PackageDetailsPage.vue?vue&type=script&lang=js"
export * from "./PackageDetailsPage.vue?vue&type=script&lang=js"

import "./PackageDetailsPage.vue?vue&type=style&index=0&id=172b333a&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__